import React, { memo } from 'react';
export function ProductPresentation() {
  const tomo1 = [{
    num: 1,
    title: 'La Biología del Trauma Ancestral',
    desc: 'Por qué tus miedos pueden no ser tuyos. La Epigenética aplicada a tu vida.'
  }, {
    num: 2,
    title: 'El Útero como Vasija de Sombra',
    desc: 'Identificá qué memorias de dolor se alojaron en tu pelvis y cómo liberarlas.'
  }, {
    num: 3,
    title: 'Cartografía del Árbol de las Mujeres',
    desc: 'Cómo dibujar tu genograma y ver el patrón que se repite en tu clan.'
  }, {
    num: 4,
    title: 'Las Lealtades Invisibles',
    desc: 'Por qué saboteás tu felicidad para no "traicionar" a tu madre sufrida.'
  }, {
    num: 5,
    title: 'El Corte de Lazos',
    desc: 'De la Hija a la Mujer Soberana. El proceso de Reparentamiento paso a paso.'
  }, {
    num: 6,
    title: 'Rituales de Alquimia Uterina',
    desc: 'Sahumado pélvico, respiración ovárica y cristales de sanación.'
  }, {
    num: 7,
    title: 'La Integración — Bendición de Linaje',
    desc: 'Transformá el veneno del pasado en medicina del futuro.'
  }];
  const tomo2 = [{
    num: 1,
    title: 'El Templo de los Senos',
    desc: 'La anatomía de la nutrición emocional y el arte de recibir sin culpa.'
  }, {
    num: 2,
    title: 'El Puente Útero-Corazón',
    desc: 'La Respiración de la Órbita Femenina para mover energía estancada.'
  }, {
    num: 3,
    title: 'El Canto de la Diosa',
    desc: 'Mantras sagrados para sanar el linaje con el poder de tu propia voz.'
  }, {
    num: 4,
    title: 'Meditación de Reparentamiento',
    desc: 'Convertirte en la madre que necesitaste y no tuviste.'
  }, {
    num: 5,
    title: 'Rituales de Luna y Ciclicidad',
    desc: 'Sincronizarte con el cosmos para potenciar cada proceso.'
  }, {
    num: 6,
    title: 'El Despertar de la Ancestra de Luz',
    desc: 'Establecé los "No Negociables" de tu nueva identidad soberana.'
  }, {
    num: 7,
    title: 'La Bendición Final',
    desc: 'Decreto de las 7 Generaciones Futuras para sellar tu transformación.'
  }];
  return <section className="py-8 px-4 bg-soft-rose" data-id="element-232">
      <div className="max-w-5xl mx-auto" data-id="element-233">
        <div className="text-center mb-10" data-id="element-234">
          <span className="text-deep-rose font-semibold tracking-wider uppercase text-xs mb-3 block" data-id="element-235">
            Presentando:
          </span>
          <h1 className="text-3xl md:text-4xl font-bold mb-3" data-id="element-236">
            ALQUIMIA DEL LINAJE
          </h1>
          <h2 className="text-xl md:text-2xl font-body font-light italic text-warm-brown mb-4" data-id="element-237">
            El Despertar del Útero y el Corazón
          </h2>
          <p className="text-lg font-medium" data-id="element-238">
            El método completo de sanación ancestral femenina en 2 Tomos.
          </p>
        </div>

        <div className="mb-12 flex justify-center" data-id="element-239">
          <img src="https://cdn.magicpatterns.com/uploads/ddWbadfbHvQJsfmQZLDLVE/Gemini_Generated_Image_4a98x44a98x44a98.png" alt="Alquimia del Linaje - 2 Tomos y Tablet" className="rounded-2xl shadow-2xl max-w-full h-auto md:max-w-2xl object-cover border-4 border-white" data-id="element-240" />
        </div>

        <div className="space-y-10" data-id="element-241">
          {/* Tomo 1 */}
          <div className="bg-white rounded-3xl p-6 md:p-8 shadow-soft" data-id="element-242">
            <div className="text-center mb-6" data-id="element-243">
              <h3 className="text-2xl font-bold mb-2 flex items-center justify-center gap-3" data-id="element-244">
                <span data-id="element-245">📖</span> TOMO 1: EL DESPERTAR DEL ÚTERO Y EL HILO DE LAS
                ABUELAS
              </h3>
              <p className="text-lg text-deep-rose italic" data-id="element-246">
                Sanación de Raíz y Linaje Materno
              </p>
            </div>

            <div className="overflow-x-auto" data-id="element-247">
              <table className="w-full text-left border-collapse" data-id="element-248">
                <thead data-id="element-249">
                  <tr className="border-b-2 border-soft-rose" data-id="element-250">
                    <th className="py-3 px-3 w-10 text-warm-brown text-sm" data-id="element-251">
                      #
                    </th>
                    <th className="py-3 px-3 w-1/3 text-warm-brown text-sm" data-id="element-252">
                      Capítulo
                    </th>
                    <th className="py-3 px-3 text-warm-brown text-sm" data-id="element-253">
                      Lo que vas a descubrir
                    </th>
                  </tr>
                </thead>
                <tbody className="divide-y divide-soft-rose/50" data-id="element-254">
                  {tomo1.map(ch => <tr key={ch.num} className="hover:bg-soft-rose/20 transition-colors" data-id="element-255">
                      <td className="py-3 px-3 font-bold text-deep-rose text-sm" data-id="element-256">
                        {ch.num}
                      </td>
                      <td className="py-3 px-3 font-semibold text-warm-brown-dark text-sm" data-id="element-257">
                        {ch.title}
                      </td>
                      <td className="py-3 px-3 text-warm-brown text-sm" data-id="element-258">
                        {ch.desc}
                      </td>
                    </tr>)}
                </tbody>
              </table>
            </div>
          </div>

          {/* Tomo 2 */}
          <div className="bg-white rounded-3xl p-6 md:p-8 shadow-soft" data-id="element-259">
            <div className="text-center mb-6" data-id="element-260">
              <h3 className="text-2xl font-bold mb-2 flex items-center justify-center gap-3" data-id="element-261">
                <span data-id="element-262">📖</span> TOMO 2: EL TEMPLO DE LOS CORAZONES Y EL CANTO DE
                LA DIOSA
              </h3>
              <p className="text-lg text-deep-rose italic" data-id="element-263">
                Sanación de Senos, Apertura del Corazón y Despertar de la Voz
              </p>
            </div>

            <div className="overflow-x-auto" data-id="element-264">
              <table className="w-full text-left border-collapse" data-id="element-265">
                <thead data-id="element-266">
                  <tr className="border-b-2 border-soft-rose" data-id="element-267">
                    <th className="py-3 px-3 w-10 text-warm-brown text-sm" data-id="element-268">
                      #
                    </th>
                    <th className="py-3 px-3 w-1/3 text-warm-brown text-sm" data-id="element-269">
                      Capítulo
                    </th>
                    <th className="py-3 px-3 text-warm-brown text-sm" data-id="element-270">
                      Lo que vas a descubrir
                    </th>
                  </tr>
                </thead>
                <tbody className="divide-y divide-soft-rose/50" data-id="element-271">
                  {tomo2.map(ch => <tr key={ch.num} className="hover:bg-soft-rose/20 transition-colors" data-id="element-272">
                      <td className="py-3 px-3 font-bold text-deep-rose text-sm" data-id="element-273">
                        {ch.num}
                      </td>
                      <td className="py-3 px-3 font-semibold text-warm-brown-dark text-sm" data-id="element-274">
                        {ch.title}
                      </td>
                      <td className="py-3 px-3 text-warm-brown text-sm" data-id="element-275">
                        {ch.desc}
                      </td>
                    </tr>)}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </section>;
}